import { render, staticRenderFns } from "./widget_portfolio_changes.vue?vue&type=template&id=e1879804&scoped=true&"
import script from "./widget_portfolio_changes.vue?vue&type=script&lang=js&"
export * from "./widget_portfolio_changes.vue?vue&type=script&lang=js&"
import style0 from "./widget_portfolio_changes.vue?vue&type=style&index=0&id=e1879804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1879804",
  null
  
)

export default component.exports